import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  DisablableOption,
  ModelBase
} from "@models";
import { 
  Character,
  CharacterFeat,
  CharacterFeature,
  FeatFeature,
  Feat,
} from "@dndModels";
import { FeatTier } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";
import FilterBox from "@dndComponents/filtering/FilterBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CheckBox from "@components/input/CheckBox";
import SelectObjectIndex from "@dndComponents/select/SelectObjectIndex";

interface Props {
  character: Character;
  obj: CharacterFeat;
  char_feature?: CharacterFeature;
  onChange: (changed: CharacterFeat, do_main: boolean) => void;
  color?: string; 
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterFeatBoxOld({ 
  character,
  obj,
  char_feature,
  onChange,
  color = ""
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  // const [ping, setPing] = useState(false);
  const [feats, setFeats] = useState<Feat[]>([]);
  const [recalc, setRecalc] = useState(false);
  const [options, setOptions] = useState<DisablableOption[]>([]);
  const [filter, setFilter] = useState<any>({});
  const [table_mode, setTableMode] = useState(false);
  
   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const load = () => {
    setLoading(true);
    // api.getObjects({ data_type: "feat", character_options: character.character_options }).then(res => {
    const new_feats = data_util.feats;
    setFeats(new_feats);
    setRecalc(true);
    // });
    setFetched(true);
  }

  const calc_use_list = () => {
    // debugger;
    const ignore_us = character.feats.filter(char_feat => 
      char_feat.source && !char_feat.source.repeatable &&
      char_feat.source_id !== obj.source_id).map(char_feat => { return char_feat.source_id; });
    let use_list = feats.filter(o => 
      !ignore_us.includes(o._id) &&
      common_util.anyOverlaps(["",...character.character_options.source_books], o.source_book_ids));
    if (!character.character_options.allow_monster_feature_sources) {
      use_list = use_list.filter(o => !o.monster);
    }
    let allowed_tiers: FeatTier[] = ["Origin"];
    if (character.character_options.allow_eberron) {
      allowed_tiers.push("Dragonmark");
    }
    // debugger;
    // let max_level = Math.max(character.character_level, 1);
    if (char_feature && char_feature.floating_feature instanceof FeatFeature) {
      const ff = char_feature.floating_feature;
      let new_feat_ids: string[] = [];
      // let ignore_special_feat_type = false;
      if (ff.standard) {
        if (character.character_level > 3) {
          allowed_tiers.push("General");
          if (character.character_level > 18) {
            allowed_tiers.push("Epic");
          }
        }
        if (character.special_feat_accesses.includes("Fighting Style")) {
          allowed_tiers.push("Fighting Style");
        }
        // max_level = ff.max_level;
      // } else if (max_level < 4) {
      //   max_level = 4;
      } else {
        allowed_tiers = [...ff.feat_tiers];
      }
      new_feat_ids = ff.feat_ids;
      if (!new_feat_ids.includes("Any") && new_feat_ids.length > 0) {
        use_list = use_list.filter(o => new_feat_ids.includes(o._id));
        // ignore_special_feat_type = true;
      }
      // if (ff.special_feat_types.length > 0) {
      //   use_list = use_list.filter(o => ff.special_feat_types.includes(o.special_feat_type));
      //   ignore_special_feat_type = true;
      // }
      // if (!ignore_special_feat_type) {
      //   use_list = use_list.filter(o => o.special_feat_type === "" || character.special_feat_accesses.includes(o.special_feat_type));
      // }
    } else if (char_feature === undefined) {
      allowed_tiers.push("General");
    }
    // if (max_level < 20) {
    //   use_list = use_list.filter(o => o.level <= max_level);
    // }
    if (allowed_tiers.length > 0) {
      use_list = use_list.filter(o => allowed_tiers.includes(o.feat_tier));
    }
    // console.log(use_list);
    if (Object.keys(filter).length > 0) {
      use_list = api.filter("feat", use_list, filter) as Feat[];
    }
    const ignore_disabled = character.character_options.ignore_limitations.includes("Feats");
    const display_unfit_items = ignore_disabled || character.character_options.display_unfit_items.includes("Feats");
    const new_options: DisablableOption[] = [];
    const char_feat_ids = [
      ...character.feats.map(o => o.source_id),
      ...character.feats.map(o => o.source?.variant_of_id??"")].filter(o => o !== "");
    for (const item of use_list) {
      // if (item.name.includes("Drow")) {
      //   console.log(item);
      // }
      const reason = char_util.fitLimits(character, item.limitations,"feat", item._id); // , item.name.includes("Drow"));
      if (display_unfit_items || reason === "true") {
        // Check for variants that character already has
        if (char_feat_ids.includes(item._id) || char_feat_ids.includes(item.variant_of_id)) {
          // Some Feats are repeatable though, so if it's repeatable check if they have the actual Feat.  Versions should still be disabled though.
          if (obj.source_id === item._id || (item.repeatable && character.feats.find(o => o.source_id === item._id))) {
            new_options.push({ id: item._id, text: item.true_name, disabled: reason !== "true", reason });
          } else {
            new_options.push({ id: item._id, text: item.true_name, disabled: true, reason: "You already have a variant of this Feat" });
          }
        } else {
          new_options.push({ id: item._id, text: item.true_name, disabled: reason !== "true", reason });
        }
      }
    }
    setOptions(new_options.sort((a,b) => {return a.text.localeCompare(b.text)}));
    setLoading(false);
  }

  const updateFilter = (changed: any = {}) => {
    const new_filter = {...changed};
    setFilter(new_filter);
    setRecalc(true);
  }

  useEffect(() => {
    if (recalc) {
      setRecalc(false);
      calc_use_list();
    }
    // eslint-disable-next-line
  }, [recalc, setRecalc]);

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    if (options.length === 1 && options[0].id === obj.source_id) {
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            className="header"
            size={{
              xs: 12
            }}>
            { obj.name }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <DisplayStringWithReplacements display_string={obj.description} />
          </Grid>
        </Grid>
      );
    } else {
      // console.log(options.filter(o => o.text.includes("Spell Sniper")));
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <CheckBox
              name="Use Table"
              value={table_mode}
              onChange={setTableMode}
            />
          </Grid>
          { table_mode ? 
            <>
              { !reloading && obj.source &&
                <>
                  <Grid
                    className='header'
                    size={{
                      xs: 12
                    }}>Current: { char_util.getUseName(obj) }</Grid>
                </>
              }
              <Grid
                size={{
                  xs: 12
                }}>
                <SelectObjectIndex
                  data_type="feat"
                  flat
                  extra_filter={(feat: ModelBase) => {
                    return feat instanceof Feat && options.filter(o2 => o2.id === feat._id).length > 0;
                  }}
                  disableObj={(feat: ModelBase) => {
                    const opt = options.find(o => o.id === feat._id);
                    if (opt) {
                      return { disabled: opt.disabled === true, reasons: opt.reason !== undefined && opt.reason !== "true" ? opt.reason : "" };
                    }
                    return { disabled: true, reasons: "Missing" };
                  }}
                  filter={filter}
                  updateFilter={updateFilter}
                  onClick={ async (changed: ModelBase) => {
                    if (changed instanceof Feat) {
                      if (obj.source) {
                        char_util.removeCharFeatureBasesFor(character, obj);
                        obj.char_feature_bases = [];
                      }
                      await api.loadObject(changed);
                      obj.copy_source({ char: character, feature_source: changed, parent_cf: char_feature });
                      onChange(obj, false);
                      setReloading(true);
                    }
                  }}
                />
              </Grid>
            </>
          :
            <>
              <Grid
                size={{
                  xs: 12
                }}>
                <FilterBox 
                  data_type="feat"
                  flat
                  all_objects={feats}
                  onChange={updateFilter}
                  onLoad={updateFilter}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12
                }}>
                <SelectStringBox
                  name="Feat"
                  value={obj.source_id as string}
                  color={obj.source_id === "" ? "blue" : ""}
                  options={options}
                  ignore_disabled={character.character_options.ignore_limitations.includes("Feats")}
                  // log_it
                  onChange={ async (id: string) => {
                    if (obj.source) {
                      char_util.removeCharFeatureBasesFor(character, obj);
                      obj.char_feature_bases = [];
                    }
                    const new_feat = feats.find(o => o._id === id);
                    if (new_feat) {
                      await api.loadObject(new_feat);
                      obj.copy_source({ char: character, feature_source: new_feat, parent_cf: char_feature });
                      onChange(obj, false);
                    }
                    setReloading(true);
                  }}
                />
              </Grid>
              { !reloading && obj.source &&
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <DisplayStringWithReplacements display_string={obj.description} />
                </Grid>
              }
            </>
          }
        </Grid>
      );
    }
  }
}
